<div class="new_bar slide-in-left container-toggled">
  <div class="sidebar">
    <app-side-bar></app-side-bar>
  </div>
  <div class="main-layout">
    <div class="header">
      <app-expiration-banner *ngIf="showAlert" [type]="alertType" [expirationDate]="userData.planExpiration" (closeAlert)="closeAlert()" />
      <app-header-new></app-header-new>
    </div>
    <div class="body">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
